import React, { useState } from 'react';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const ROI = () => {
  const [cost, setCost] = useState('');
  const [revenue, setRevenue] = useState('');
  const [roi, setRoi] = useState(null);

  const handleCostChange = (e) => setCost(e.target.value);
  const handleRevenueChange = (e) => setRevenue(e.target.value);

  const calculateROI = () => {
    const costValue = parseFloat(cost);
    const revenueValue = parseFloat(revenue);

    if (isNaN(costValue) || isNaN(revenueValue) || costValue === 0) {
      setRoi('Invalid input. Please enter valid numbers.');
      return;
    }

    const roiValue = ((revenueValue - costValue) / costValue) * 100;
    setRoi(roiValue.toFixed(2) + '%');
  };

  return (
    <>
    <SEO
      title="Film ROI Calculator"
      description="Calculate the return on investment for your film project using ProducerBuddy's ROI analysis and financial modelling tools."
      url="https://producerbuddy.pilomation.com/roi"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
      <div className="max-w-4xl w-full bg-white rounded-lg shadow-lg p-4">
        <h2 className="text-4xl font-bold mb-6 text-gray-800 text-center">
          ROI Calculator
        </h2>
        
        <div className="mb-8">
          <h4 className='text-lg font-semibold text-gray-700 mb-2'>What is ROI?</h4>
          <p className="text-gray-600">
            ROI (Return on Investment) is a financial metric used to evaluate the efficiency or profitability of an investment. It measures the return on an investment relative to its cost. ROI is expressed as a percentage and is a key performance indicator (KPI) used to assess the effectiveness 
            of investments, including marketing campaigns, business projects, and various other financial endeavors.
          </p>
        </div>
        
        <div className="mb-8 mt-2">
          <h4 className='text-lg font-semibold text-gray-700 mb-2'>How is it calculated?</h4>
          <p className="text-gray-600">
            ROI = (Net Profit / Cost of Investment) × 100
          </p>
          <p className="text-gray-600">
            Where:
          </p>
          <p className="text-gray-600">
            <strong>Net Profit</strong> is the total revenue generated from the investment minus the cost of the investment.
          </p>
          <p className="text-gray-600">
            <strong>Cost of Investment</strong> is the initial amount spent on the investment.
          </p>
        </div>
        
        <div className="bg-gray-50 p-6 rounded-lg shadow-md mt-4">
          <div className="mb-6">
            <label className="block text-gray-700 text-md font-semibold mb-2">Promotion Cost:</label>
            <input
              type="number"
              value={cost}
              onChange={handleCostChange}
              placeholder="Enter promotion cost"
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
            />
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 text-md font-semibold mb-2">Revenue Generated:</label>
            <input
              type="number"
              value={revenue}
              onChange={handleRevenueChange}
              placeholder="Enter revenue generated"
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
            />
          </div>

          <div className="text-center mb-6">
            <button
              onClick={calculateROI}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition duration-300"
            >
              Calculate ROI
            </button>
          </div>

          {roi !== null && (
            <div className="text-center">
              <h3 className="text-2xl font-semibold text-gray-800 mb-2">ROI:</h3>
              <p className="text-xl text-gray-700">{roi}</p>
            </div>
          )}
        </div>
      </div>
    </div>
    </>
    
  );
};

export default ROI;

